module.exports = __webpack_public_path__ + "static/media/Nexus 4.73fb5d69.png";